"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var React = require("react");
require("../../../common/buttons/btn.scss");
var UserStatusToggle = function (_a) {
    var _b = _a.is_active, is_active = _b === void 0 ? 0 : _b, _c = _a.userId, userId = _c === void 0 ? '' : _c;
    var getChipStyle = function (active) {
        return active
            ? { background: '#EAF3DE', color: '#27500A' }
            : { background: '#FCEBEB', color: '#791F1F' };
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(material_1.Chip, { label: is_active ? 'Active' : 'Inactive', size: "small", style: __assign(__assign({}, getChipStyle(is_active === 1)), { fontSize: '12px', fontWeight: 500, height: '28px', borderRadius: '16px' }) })));
};
exports.default = UserStatusToggle;
